import { http, httpgst } from '../../main'
import { store } from '../../store'

const actions = {
  getLogged ({commit, dispatch}, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getUsers ({commit, dispatch}, payload) {
    let url = 'api/user'
    let options = {
      emulateJSON: false,
      'Content-Type': 'application/json'
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetUsers', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getSubstitutes ({commit, dispatch}, payload) {
    let url = 'api/substitute/' + payload.event.id
    let options = {
      emulateJSON: false,
      'Content-Type': 'application/json'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetSubstitutes', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  post ({commit, dispatch}, payload) {
    let url = 'api/substitute'
    let params = {
      'user_id': payload.event.item.user_id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  delete ({commit, dispatch}, payload) {
    let url = 'api/substitute/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

const mutations = {
  onGetLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  },
  onGetUsers (state, payload) {
    let users = payload.response.data.data
    payload.event.context.users = users
  },
  onGetSubstitutes (state, payload) {
    let substitutes = payload.response.data.data
    payload.event.context.loading = false
    payload.event.context.substitutes = substitutes
    payload.event.context.loadingItems = false
  },
  onPost (state, payload) {
    let substitute = payload.response.data.data
    let substitutes = payload.event.context.substitutes
    substitutes.push(substitute)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  onDelete (state, payload) {
    let substitute = payload.event.context.substitutes
    substitute.splice(payload.event.index, 1)
    payload.event.context.closeRemove()
    payload.event.context.showNotification(payload.response, 'success')
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/substitutes.js